<template>
    <span>
        <span v-if="buttonCode" style="margin-right: 5px">
              <el-button :style="{background:color?color+'!important':'',borderColor:color?color+'!important':''}" :type="btnType || 'primary'" :icon="iconName" :size="size" :disabled="disabled"
                         @click="clickEvent()">
                   <slot></slot>
             </el-button>
        </span>
        <span v-else style="margin-right: 5px">
            <span v-if="label=='查看'">
                <el-button :style="{background:color?color+'!important':'',borderColor:color?color+'!important':''}" :icon="iconName" :type="btnType || 'primary'" :size="size" @click="clickEvent()">
                       <slot></slot>
                </el-button>
            </span>
            <span v-else>
                <el-button :style="{background:color?color+'!important':'',borderColor:color?color+'!important':''}" :icon="iconName" :type="btnType || 'primary'" :size="size" :disabled="disabled" @click="clickEvent()">
                    <slot></slot>
                </el-button>
            </span>
        </span>
    </span>

</template>

<script>

    export default {
        name: "Button",
        props:{
            disabled: {
                type: Boolean,
                default: false
            },
            size: {
                type: String,
                default: '',
            },
            buttonCode: {
                type: String,
                default: ''
            },
            iconName: {
                type: String,
                default: ''
            },
            btnType: {
                type: String,
                default: ''
            },
            label:{
                type: String,
                default: ''
            },
			color:{
				type:String,
				default:''
			}
        },
        data(){
            return{

                newDisabled:false,
                curBtn: {
                    checked: true
                },

            }
        },
        methods:{
            clickEvent(){
                this.$emit('clickEvent')
            },
        },
        mounted() {
            if(this.$route.query.disabled){this.disabled = this.$route.query.disabled?true:false}
            // this.curBtn = this.PublicFn.getCanButton(this.$store.state.configMenuList, this.buttonCode)
                // ?this.PublicFn.getCanButton(this.$store.state.configMenuList, this.buttonCode):{checked: true };
        }
    }
</script>

<style lang="less" scoped>
    @import "button";
</style>

